export const namespace = 'timeZone';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const ActionType = {
  SET_TIME_ZONES: `${namespace}/SET_TIME_ZONES`,
  SET_TIME_ZONE_STATUS: `${namespace}/SET_TIME_ZONE_STATUS`,
  LOAD_TIME_ZONES: `${namespace}/LOAD_TIME_ZONES`
};

export const setTimeZones = (timeZones = []) => ({
  type: ActionType.SET_TIME_ZONES,
  payload: {
    timeZones
  }
});

export const loadTimeZones = () => ({
  type: ActionType.LOAD_TIME_ZONES
});

export const setTimeZoneStatus = (status) => ({
  type: ActionType.SET_TIME_ZONE_STATUS,
  payload: {
    status
  }
})
